import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {HomeComponent} from './home.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {SharedModule} from '../common/SharedModule';
import {CustomCardComponent} from './custom-card/custom-card.component';

@NgModule({
    declarations: [
        HomeComponent,
        CustomCardComponent,
    ],
    imports: [
        CommonModule,
        FlexLayoutModule,
        SharedModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule,
    ],
    exports: [
        HomeComponent,
    ]
})
export class HomeModule {
}
